import React from 'react';
import { useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useTheme } from '../contexts/ThemeContext';
export default function ThemePicker() {
  const { preference, setPreference } = useTheme();
  return <select className="theme-picker" aria-label="Görünüm teması" title="Görünüm teması" value={preference} onChange={e => setPreference(e.target.value)}>
    <option value="light">Açık</option><option value="dark">Koyu</option><option value="system">Sistem</option>
  </select>;
}
export function PublicThemePicker() {
  const { pathname } = useLocation();
  return ['/', '/login', '/register', '/forgot-password', '/reset-password', '/auth/google', '/venue/invite-register'].includes(pathname) || pathname.startsWith('/mekan-davet/')
    ? <div className="auth-theme-toolbar"><span>Görünüm</span><ThemePicker /></div> : null;
}
export function ThemeToaster() {
  const { resolved } = useTheme();
  return <Toaster position="top-right" theme={resolved} />;
}
